const messages = {
  projectsDescription: "Conoce nuestros más recientes proyectos",
  ourProjects: "Conoce Nuestros Proyectos",
  ourClients: "Nuestros Clientes",
  btnShow: "Ver"
};
export default messages;
